let navigator = null
let notifier = null

export const httpEventBus = {
    setNavigator(fn) {
        navigator = fn
    },
    setNotifier(fn) {
        notifier = fn
    },
    navigate(to, options) {
        if (navigator) navigator(to, options)
    },
    notify(message, severity = 'error') {
        if (notifier) notifier(message, severity)
    },
}
